<template>
  <v-app id="home">
  <v-layout   >
     <router-view></router-view>
  </v-layout>

  <v-footer padless>
      <v-col class="text-center" cols="12">
        {{ new Date().getFullYear() }} <strong>TA</strong> - v{{ appVersion }}
      </v-col>
    </v-footer>

  </v-app>
</template>

<script>
import packageJson from '../package.json'


export default {
  name: 'App',
  props: {},
  data() {
    return {
      appVersion: packageJson.version,
    }
  },
}

</script>

